import 'css-chunksrc/client/scenes/chatbot/messages/messageBubble/styles.scss';export default {
  "messageBubble": "_messageBubble_1xpv7_1",
  "user": "_user_1xpv7_9",
  "content": "_content_1xpv7_14",
  "bot": "_bot_1xpv7_20",
  "avatar": "_avatar_1xpv7_30",
  "assistantAvatar": "_assistantAvatar_1xpv7_36"
};